module.exports = __webpack_public_path__ + "media/images/ecute/ecuteueno_ko-814a3df1b82eaf01c404bf94204619d2.jpg";